import { CustomDropdownWithSelect } from "Components/CommonComponents/CustomDropdownWithSelect";
import Typography from "Components/CommonComponents/Typography";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card, Col, Collapse, Row, Spinner } from "reactstrap";
import {
  BASE_URL,
  FETCH_ATTENDANCE_DATA,
} from "utilFunctions/Constants/urlConstants";
import "./studentAttendance.css";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import UpArrowIcon from "Assets/Icons/UpArrowIcon";
import DownArrowIcon from "Assets/Icons/DownArrowIcon";
import StudentPerformanceGraph from "Pages/BranchHealth/Student/StudentPerformanceGraph";
import { StudentContext } from "Context/StudentContext";
// import StudentWeaknesStrengthComponent from "Pages/StudentPortfolio/StudentLOPSection/StudentWeaknesStrengthComponent";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import StudentAttendanceTable from "Pages/StudentPortfolio/StudentAttendanceSection/StudentAttendanceTable";
// const datat = {
//   code: "msg",
//   data: [
//     {
//       month: "MARCH",
//       subjects: {
//         Chemistry: {
//           attendantClassCount: 4,
//           totalClassScheduled: 4,
//         },
//         Zoology: {
//           attendantClassCount: 3,
//           totalClassScheduled: 5,
//         },
//         Botany: {
//           attendantClassCount: 2,
//           totalClassScheduled: 3,
//         },
//         Physics: {
//           attendantClassCount: 9,
//           totalClassScheduled: 9,
//         },
//       },
//     },
//     {
//       month: "APRIL",
//       subjects: {
//         Chemistry: {
//           attendantClassCount: 1,
//           totalClassScheduled: 2,
//         },
//         Zoology: {
//           attendantClassCount: 2,
//           totalClassScheduled: 3,
//         },
//         Botany: {
//           attendantClassCount: 2,
//           totalClassScheduled: 3,
//         },
//         Physics: {
//           attendantClassCount: 6,
//           totalClassScheduled: 6,
//         },
//       },
//     },
//   ],
// };
export interface filterIFC {
  acadYearState?: {
    label: string;
    value: string;
  };
  testTypeState?: any | null;
  subjectState?: any | null;
}
function StudentAttendanceMain() {
  const location = useLocation();
  const { state } = location;
  const { selectedStudent: ContextStudent } = useContext<any>(StudentContext);
  //   const student = useContext<any>(StudentContext);
  const selectedStudent =
    state &&
    state != null &&
    state?.selectedStudent &&
    state?.selectedStudent != null &&
    state?.selectedStudent.stream
      ? state.selectedStudent
      : ContextStudent;
  const [filterState, setFilterState] = useState<filterIFC>({
    acadYearState: selectedStudent?.academicYear
      ? selectedStudent.academicYear
      : { label: "--select--", value: selectedStudent?.clazz },
    testTypeState: null,
    subjectState: null,
  });
  const [attendanceTableData, setAttendanceTableData] = useState<any>([]);
  const [showFilter, setShowFilter] = useState<any>(false);
  const [isOpenTestPerformance, setIsOpenTestPerformance] = useState<any>(true);
  const [barArray, setBarArray] = useState<any>([]);
  const [tableHeading, setTableHeading] = useState<any>([
    { label: "Month", value: "month" },
  ]);
  const { makeRequest, loading, responseData } = useGetApi(
    (data: any) => {
      onSuccess(data);
    },
    (error: any) => {
      onerror(error);
    }
  );
  const onSuccess = (data: any) => {
    console.log(selectedStudent.clazz, "selectedStudent.clazz", data);
  };

  const onerror = (data: any) => {
    console.log("Performance data", data);
  };
  useEffect(() => {
    if (responseData?.data) {
      const datacopy: any = [];

      setAttendanceTableData(responseData?.data);
      let maxSubjects = 0;
      let monthIndex = -1;

      responseData?.data.forEach((item: any, index: any) => {
        const subjectsCount = Object.keys(item.subjects).length;
        if (subjectsCount > maxSubjects) {
          maxSubjects = subjectsCount;
          monthIndex = index;
        }
      });

      if (monthIndex !== -1) {
        const monthWithMostSubjects = responseData?.data[monthIndex];
        Object.keys(monthWithMostSubjects.subjects).map((item) => {
          datacopy.push({ label: item, value: item });
        });
      } else {
        console.error("no subjects found");
      }
      const newtableheading = [...tableHeading, ...datacopy];
      const unique = newtableheading.filter((obj, index) => {
        return (
          index === newtableheading.findIndex((o) => obj.value === o.value)
        );
      });

      setTableHeading([...unique]);
      // Create a map to store total attendance and total classes for each student
      const attendanceByStudent: any = {};

      // Aggregate attendance data for each student across all subjects and months
      responseData?.data.forEach((monthData: any) => {
        const subjects = monthData.subjects;
        Object.keys(subjects).forEach((subject) => {
          const attendantClassCount = subjects[subject].attendantClassCount;
          const totalClassScheduled = subjects[subject].totalClassScheduled;

          if (!attendanceByStudent[monthData.month]) {
            attendanceByStudent[monthData.month] = {
              totalAttendance: 0,
              totalClasses: 0,
            };
          }

          attendanceByStudent[monthData.month].totalAttendance +=
            attendantClassCount;
          attendanceByStudent[monthData.month].totalClasses +=
            totalClassScheduled;
        });
      });

      // Calculate average attendance for each student for each month
      const averageAttendanceByMonth: any = {};
      console.log(attendanceByStudent, "attendanceByStudent");
      Object.keys(attendanceByStudent).forEach((month) => {
        const totalAttendance = attendanceByStudent[month].totalAttendance;
        const totalClasses = attendanceByStudent[month].totalClasses;
        averageAttendanceByMonth[month] = Math.round(
          (totalAttendance / totalClasses) * 100
        );
      });
      setBarArray(averageAttendanceByMonth);
      console.log(averageAttendanceByMonth, "averageAttendanceByMonth");
    }
  }, [responseData?.data]);
  useEffect(() => {
    if (selectedStudent?.academicYear) {
      setFilterState({
        acadYearState: selectedStudent?.academicYear
          ? selectedStudent.academicYear
          : { label: "--select--", value: selectedStudent.clazz },
        testTypeState: null,
        subjectState: null,
      });
    }
    if (selectedStudent?.psid && selectedStudent.stream) {
      const url =
        BASE_URL + FETCH_ATTENDANCE_DATA + `?psid=${selectedStudent.psid}`;
      makeRequest(url);
    }
  }, [selectedStudent?.psid]);

  const toggle = () => setIsOpenTestPerformance(!isOpenTestPerformance);
  const toggltePerformanceVisible = () => {
    setShowFilter(!showFilter);
  };
  const clearAllPerformanceVisible = () => {
    setFilterState({
      acadYearState: selectedStudent?.academicYear
        ? selectedStudent.academicYear
        : { label: "--select--", value: selectedStudent.clazz },
      testTypeState: null,
      subjectState: null,
    });
    toggltePerformanceVisible();
  };

  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
    if (name == "acadYearState") {
      const url =
        BASE_URL +
        FETCH_ATTENDANCE_DATA +
        `?psid=${selectedStudent.psid}&clazz=${val.value}&academicYear=${val.label}`;
      makeRequest(url);
      setFilterState((prevState: any) => ({
        ...prevState,
        testTypeState: null,
        subjectState: null,
      }));
    }
  };

  return (
    <div className="mt-3">
      <Card className="p-3">
        <>
          <div className="w-100 d-flex flex-row justify-content-between barGraphHeading">
            <div className="LopStudentnamelegendContainerMain">
              <Typography variant="h6" color="black">
                Class Attendance
              </Typography>
              <div className="LopStudentnamelegendContainer">
                <div className="LopStudentnamelegend"></div>
                <Typography variant="forminfo" color="black">
                  {selectedStudent?.name}
                </Typography>
              </div>
            </div>

            {showFilter ? (
              <>
                <div className="w-50 d-flex flex-row filtersPerformanceDiv justify-content-end">
                  <div>
                    <CustomDropdownWithSelect
                      placeholderLabel="Test Type"
                      placeholder=""
                      width={240}
                      allowSelectAll={true}
                      options={[{ label: "--select--", value: null }]}
                      isSearchableDrop={true}
                      isDropdownSelect={true}
                      isMulti={true}
                      isSearchable={true}
                      isClearable={false}
                      isDisabled={false}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      menuPlacement="bottom"
                      menuShouldScrollIntoView={true}
                      onChange={(selected: any) => {
                        handleAddFilterArrayList("testTypeState", selected);
                      }}
                      value={filterState.testTypeState}
                      data-minimum-results-for-search="Infinity"
                    />
                  </div>
                  <div className="betweenFilter">
                    <CustomDropdownWithSelect
                      placeholderLabel="Subject"
                      placeholder=""
                      width={240}
                      allowSelectAll={true}
                      options={[{ label: "--select--", value: null }]}
                      isMulti={true}
                      isSearchableDrop={true}
                      isDropdownSelect={true}
                      isSearchable={true}
                      isClearable={false}
                      isDisabled={false}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      menuPlacement="bottom"
                      menuShouldScrollIntoView={true}
                      onChange={(selected: any) => {
                        handleAddFilterArrayList("subjectState", selected);
                      }}
                      value={filterState.subjectState}
                      data-minimum-results-for-search="Infinity"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center ml-3"
                    onClick={() => clearAllPerformanceVisible()}
                  >
                    <span className="filterSpan">Reset All</span>
                  </div>
                  <div className="cursorHoverCSS" onClick={toggle}>
                    {isOpenTestPerformance ? (
                      <UpArrowIcon />
                    ) : (
                      <DownArrowIcon />
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="d-flex flex-row">
                {/* <div
                  className="d-flex align-items-center mt-n2"
                  onClick={() => toggltePerformanceVisible()}
                >
                  <span className="filterSpan">Filter</span>
                  <FilterIcon className="cursor-pointer" />
                </div> */}
                <div className="cursorHoverCSS" onClick={toggle}>
                  {isOpenTestPerformance ? <UpArrowIcon /> : <DownArrowIcon />}
                </div>
              </div>
            )}
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100 p-3">
              <Spinner color="info"></Spinner>
            </div>
          ) : (
            <Collapse isOpen={isOpenTestPerformance}>
              {attendanceTableData && attendanceTableData.length ? (
                <Row className="">
                  <Col
                    sm="12"
                    md="12"
                    lg="12"
                    className="d-flex flex-row justify-content-start mt-2"
                  >
                    <StudentPerformanceGraph
                      mode="studentAttendance"
                      barArray={barArray}
                      tableHeading={tableHeading}
                      filterState={filterState}
                      OverallPerformanceArray={attendanceTableData}
                    />
                    <StudentAttendanceTable
                      tableHeading={tableHeading}
                      tableData={attendanceTableData}
                      barArray={barArray}
                    />
                  </Col>
                </Row>
              ) : (
                <NoResultFoundSearch
                  primaryMessage="Attendance data not available"
                  secondaryMessage={
                    "The student attendance data has not been synced in the system yet; updates will be available soon."
                  }
                >
                  <NoDataFoundIcon />
                </NoResultFoundSearch>
              )}
              {/* )} */}
            </Collapse>
          )}
        </>
      </Card>
    </div>
  );
}

export default StudentAttendanceMain;
